import 'iconify-icon';
import 'simplebar';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import Toastify from 'toastify-js'

import { addCollection } from 'iconify-icon';
import solarIcons from '@iconify-json/solar/icons.json';

import * as IF from "infrontjs";

import './../components/general/app-layout'

export class View extends IF.View
{
    constructor( appInstance )
    {
        super( appInstance );
    }

    init()
    {
        // Solar Iconset registrieren
        addCollection( solarIcons );

        this.render(
            this.app.container,
            '<app-layout></app-layout>' +
            // Version and storage must match apps/www/src/public/includes/footer.php (shared consent cookie)
            '<cookie-consent policy-url="https://www.tmplvision.io/legal/privacy-policy" imprint-url="https://www.tmplvision.io/legal/imprint" consent-version="1.3" renew-days="180"></cookie-consent>'
        );

        this.app.addEventListener( IF.CustomEvents.TYPE.AFTER_STATE_CHANGE, ( e ) =>
        {
            if ( this.app.stateManager.currentState?.getContentHeaderData && this.contentHeader )
            {
                this.contentHeader.setAttribute( 'title', this.app.stateManager.currentState.getContentHeaderData().title );
                this.contentHeader.setAttribute( 'breadcrumb', JSON.stringify( this.app.stateManager.currentState.getContentHeaderData().breadcrumb ) );
            }
            window.scrollTo( { top: 0, behavior: 'smooth' } );
        } );

        if ( this.app.user )
        {
            this.switchToInApp();
        }
        else
        {
            this.switchToAuth();
        }
    }

    switchToInApp()
    {
        this.applayout = this.app.container.querySelector( 'app-layout' );
        if ( this.applayout )
        {
            this.applayout.render();
            this.contentHeader = this.app.container.querySelector( 'content-header' );
            this.pageContent = this.app.container.querySelector( 'section[data-id="page-content"]' );
        }
    }

    switchToAuth()
    {
        this.applayout = this.app.container.querySelector( 'app-layout' );
        if ( this.applayout )
        {
            this.applayout.render();
        }
        this.contentHeader = null;
        this.pageContent = null;
    }

    blockUI(element, title)
    {
        // Verhindert mehrfaches Blockieren desselben Elements
        if (element.querySelector('.block-ui-overlay')) {
            console.warn("Element ist bereits blockiert.");
            return;
        }

        // 1. Overlay-Element erstellen
        const overlay = document.createElement('div');
        overlay.className = 'block-ui-overlay';

        // 2. Nachrichten-Container erstellen
        const message = document.createElement('div');
        message.className = 'block-ui-message';
        //message.textContent = title;
        message.innerHTML += '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>' + title;

        // 3. Nachricht zum Overlay hinzufügen
        overlay.appendChild(message);

        // 4. Overlay zum Ziel-Element hinzufügen
        element.appendChild(overlay);
    }

    unblockUI(element)
    {
        const overlay = element.querySelector('.block-ui-overlay');
        if (overlay) {
            element.removeChild(overlay);
        } else {
            console.warn("Element ist nicht blockiert.");
        }
    }

    async confirm( title, text = null, confirmButtonText = "Ok" ) {
        const result = await Swal.fire({
            title: title,
            text: text,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: confirmButtonText,
        });
        return result.isConfirmed;
    }

    toast( text, type = "success" )
    {
        Toastify({
            text: text,
            // duration: 3000,
            //destination: "https://github.com/apvarun/toastify-js",
            //newWindow: true,
            //close: true,
            gravity: "bottom", // `top` or `bottom`
            position: "center", // `left`, `center` or `right`
            stopOnFocus: true, // Prevents dismissing of toast on hover
            className: "toastify-" + type,
            /*
            style: {
                //background: "linear-gradient(to right, #00b09b, #96c93d)",
                background: "#4bd08b!important"
            },*/
            //onClick: function(){} // Callback after click
        }).showToast();
    }
}
